import { defaultUrlTransform } from 'react-markdown'

const SAFE_IMAGE_CONTENT_TYPES = ['image/png', 'image/jpeg', 'image/gif']

/**
 * The URL transform for rendered chat markdown. Safe inline images pass through, other `data:` URLs
 * keep only their content-type prefix so the image renderer can explain what was dropped, and
 * everything else goes through react-markdown's default, which empties any URL with an unsafe
 * protocol (e.g. the `sandbox:/mnt/data/...` links Code Interpreter writes).
 */
export function markdownUrlTransform(url: string): string {
  if (url.startsWith('data:')) {
    const contentType = url.split(';')[0].split(':')[1]
    if (SAFE_IMAGE_CONTENT_TYPES.includes(contentType)) {
      return url
    }
    // Return the data URL contentType prefix used for processing downstream, but drop the unsafe data
    return `data:${contentType};base64,`
  }

  return defaultUrlTransform(url)
}

export function isSafeImageDataContentType(contentType: string): boolean {
  return SAFE_IMAGE_CONTENT_TYPES.includes(contentType)
}

/**
 * Whether a transformed href actually goes somewhere. An empty href resolves to the current page,
 * so a link whose URL was stripped as unsafe would otherwise open the chat session again in a new
 * tab (WF-2736), which is worse than showing the link text on its own.
 */
export function isNavigableHref(href: string | undefined | null): href is string {
  return typeof href === 'string' && href.trim().length > 0
}
